import { FC, ReactNode } from 'react'

interface ShowcaseHeaderProps {
	icon?: ReactNode
	title: string
	className?: string
}

const ShowcaseHeader: FC<ShowcaseHeaderProps> = ({ icon, title, className = '' }) => (
	<div className={`flex items-center gap-4 mb-4 ${className}`}>
		{icon && <div className="bg-white rounded-full p-2">{icon}</div>}
		<h3 className="text-xl font-semibold">{title}</h3>
	</div>
)

export default ShowcaseHeader
